/**
 * 返回动画效果
 */

const PI = Math.PI,
  pow = Math.pow,
  sin = Math.sin;

const Easing = {
  swing: t => {
    return -Math.cos(t * PI) / 2 + 0.5;
  },

  /**
   * Uniform speed between points.
   */
  easeNone: t => {
    return t;
  },

  /**
   * Begins slowly and accelerates towards end. (quadratic)
   */
  easeIn: t => {
    return t * t;
  },

  /**
   * Begins quickly and decelerates towards end.  (quadratic)
   */
  easeOut: t => {
    return (2 - t) * t;
  },

  /**
   * Begins slowly and decelerates towards end. (quadratic)
   */
  easeBoth: t => {
    return (t *= 2) < 1 ? 0.5 * t * t : 0.5 * (1 - --t * (t - 2));
  },

  /**
   * Begins slowly and accelerates towards end. (quartic)
   */
  easeInStrong: t => {
    return t * t * t * t;
  },

  /**
   * Begins quickly and decelerates towards end.  (quartic)
   */
  easeOutStrong: t => {
    return 1 - --t * t * t * t;
  },

  /**
   * Begins slowly and decelerates towards end. (quartic)
   */
  easeBothStrong: t => {
    return (t *= 2) < 1
      ? 0.5 * t * t * t * t
      : 0.5 * (2 - (t -= 2) * t * t * t);
  },

  /**
   * Snap in elastic effect.
   */

  elasticIn: t => {
    var p = 0.3,
      s = p / 4;
    if (t === 0 || t === 1) return t;
    return -(pow(2, 10 * (t -= 1)) * sin(((t - s) * (2 * PI)) / p));
  },

  /**
   * Snap out elastic effect.
   */
  elasticOut: t => {
    var p = 0.3,
      s = p / 4;
    if (t === 0 || t === 1) return t;
    return pow(2, -10 * t) * sin(((t - s) * (2 * PI)) / p) + 1;
  },

  /**
   * Snap both elastic effect.
   */
  elasticBoth: t => {
    var p = 0.45,
      s = p / 4;
    if (t === 0 || t === 1) return t;

    if (t < 1) {
      return -0.5 * (pow(2, 10 * (t -= 1)) * sin(((t - s) * (2 * PI)) / p));
    }
    return pow(2, -10 * (t -= 1)) * sin(((t - s) * (2 * PI)) / p) * 0.5 + 1;
  },

  /**
   * Backtracks slightly, then reverses direction and moves to end.
   */
  backIn: t => {
    if (t === 1) return t;
    var BACK_CONST = 1.70158;
    return t * t * ((BACK_CONST + 1) * t - BACK_CONST);
  },

  /**
   * Overshoots end, then reverses and comes back to end.
   */
  backOut: t => {
    var BACK_CONST = 1.70158;
    return (t -= 1) * t * ((BACK_CONST + 1) * t + BACK_CONST) + 1;
  },

  /**
   * Backtracks slightly, then reverses direction, overshoots end,
   * then reverses and comes back to end.
   */
  backBoth: t => {
    var BACK_CONST = 1.70158;
    if ((t *= 2) < 1) {
      return 0.5 * (t * t * (((BACK_CONST *= 1.525) + 1) * t - BACK_CONST));
    }
    return (
      0.5 * ((t -= 2) * t * (((BACK_CONST *= 1.525) + 1) * t + BACK_CONST) + 2)
    );
  },

  /**
   * Bounce off of start.
   */
  bounceIn: t => {
    return 1 - Easing.bounceOut(1 - t);
  },

  /**
   * Bounces off end.
   */
  bounceOut: t => {
    var s = 7.5625,
      r;

    if (t < 1 / 2.75) {
      r = s * t * t;
    } else if (t < 2 / 2.75) {
      r = s * (t -= 1.5 / 2.75) * t + 0.75;
    } else if (t < 2.5 / 2.75) {
      r = s * (t -= 2.25 / 2.75) * t + 0.9375;
    } else {
      r = s * (t -= 2.625 / 2.75) * t + 0.984375;
    }

    return r;
  },

  /**
   * Bounces off start and end.
   */
  bounceBoth: t => {
    if (t < 0.5) {
      return Easing.bounceIn(t * 2) * 0.5;
    }
    return Easing.bounceOut(t * 2 - 1) * 0.5 + 0.5;
  }
};

export default Easing;
